import './components/lessons_text_filter_form';
import './components/lessons_text_item';
import './index.scss';
import 'components/handle_title_segment';
import 'styles/components/_alerts.scss';
import 'styles/components/_pagination.scss';
import applyCountdown from 'utils/countdown';

(function () {
  if (gon.flags.freemium_lessons) {
    applyCountdown({
      selector: '.q-lesson-freemium-banner .limit-countdown',
      template: '%H:%M:%S'
    });
  }
})();
